/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IStockistCheckerViewProps } from './stockist-checker';

export default (props: IStockistCheckerViewProps) => {
    return <></>;
};
